// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Common Styles ========== */

/* Reset */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: var(--font-sans);
    background: var(--background);
    color: var(--text-primary);
}

.class-selector__status--ended{
    color: var(--text-tertiary);
}

.icon {
    width: 20px;
    height: 20px;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
    flex-shrink: 0;
}

.icon--sm {
    width: 16px;
    height: 16px;
}

.icon--lg {
    width: 24px;
    height: 24px;
}

.app {
    display: flex;
    height: 100vh;
}

/* ========== Main Layout ========== */
.main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: var(--surface);
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 72px 16px 24px;
    background: var(--background);
    border-bottom: 1px solid var(--border);
}

.page-header__left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.page-header__title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.page-header__right {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ========== Buttons ========== */
.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: var(--radius-md);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);
    border: none;
    font-family: var(--font-sans);
}

.btn--primary {
    background: var(--primary-600);
    color: white;
}

.btn--primary:hover {
    background: var(--primary-700);
}

.btn--outline {
    background: var(--background);
    border: 1px solid var(--border);
    color: var(--text-primary);
}

.btn--outline:hover {
    background: var(--surface);
    border-color: var(--primary-300);
}

.btn--sm {
    padding: 6px 12px;
    font-size: 12px;
}

.btn--lg {
    padding: 12px 24px;
    font-size: 14px;
}

/* ========== Modal ========== */
.common-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: opacity var(--transition-fast), visibility var(--transition-fast);
}

.common-modal-overlay--open {
    opacity: 1;
    visibility: visible;
}

.common-modal {
    background: var(--background);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);
    width: 100%;
    max-width: 1000px;
    max-height: 90vh;
    overflow: hidden;
    opacity: 0;
    transition: opacity var(--transition-fast);
}

.common-modal-overlay--open .common-modal {
    opacity: 1;
}

.modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
}

.modal__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal__close {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: var(--radius-md);
    cursor: pointer;
    color: var(--text-tertiary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color var(--transition-fast), color var(--transition-fast);
}

.modal__close:hover {
    background: var(--gray-100);
    color: var(--text-primary);
}

.modal__body {
    padding: 20px;
    max-height: 60vh;
    overflow-y: auto;
}

.modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 20px;
    border-top: 1px solid var(--border);
    background: var(--gray-50);
}

.modal__btn {
    padding: 8px 16px;
    border: 1px solid var(--border);
    background: var(--background);
    border-radius: var(--radius-md);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color var(--transition-fast), border-color var(--transition-fast);
}

.modal__btn:hover {
    background: var(--gray-100);
}

.modal__btn--primary {
    background: var(--primary-600);
    border-color: var(--primary-600);
    color: white;
}

.modal__btn--primary:hover {
    background: var(--primary-700);
}

.modal__btn--danger {
    background: var(--error);
    border-color: var(--error);
    color: white;
}

.modal__btn--danger:hover {
    background: var(--error-dark);
}

.modal--popup {
    max-width: 480px;
}

.modal--popup .modal__body {
    padding: 0;
}

.modal--popup .modal__header {
    display: none;
}

/* ========== Popup Styles ========== */
.popup-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px;
    border-bottom: 1px solid var(--border);
}

.popup-header__icon {
    width: 40px;
    height: 40px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.popup-header__icon--purple {
    background: var(--gray-100);
    color: var(--primary-600);
}

.popup-header__icon--green {
    background: var(--gray-100);
    color: var(--success);
}

.popup-header__icon--blue {
    background: var(--gray-100);
    color: var(--info);
}

.popup-header__icon--warning {
    background: var(--gray-100);
    color: var(--warning);
}

.popup-header__text {
    flex: 1 1;
}

.popup-header__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
}

.popup-header__subtitle {
    font-size: 12px;
    color: var(--text-tertiary);
    margin-top: 2px;
}

.popup-close {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: var(--radius-md);
    cursor: pointer;
    color: var(--text-tertiary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color var(--transition-fast), color var(--transition-fast);
}

.popup-close:hover {
    background: var(--gray-100);
    color: var(--text-primary);
}

.popup-search-bar {
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
    display: flex;
    gap: 12px;
}

.popup-search {
    flex: 1 1;
    position: relative;
}

.popup-search__icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-tertiary);
    pointer-events: none;
}

.popup-search__input {
    width: 100%;
    padding: 10px 12px 10px 40px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    font-size: 13px;
    font-family: var(--font-sans);
    background: var(--background);
    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.popup-search__input:focus {
    outline: none;
    border-color: var(--primary-400);
    box-shadow: var(--focus-ring);
}

.popup-search__input::placeholder {
    color: var(--text-tertiary);
}

.popup-list {
    max-height: 320px;
    overflow-y: auto;
    padding: 8px;
}

.popup-list__empty {
    text-align: center;
    padding: 40px 20px;
    color: var(--text-tertiary);
    font-size: 13px;
}

.popup-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: background 0.15s ease;
    border: 1px solid transparent;
}

.popup-item:hover {
    background: var(--gray-50);
}

.popup-item--selected {
    background: var(--primary-50);
    border-color: var(--primary-200);
}

.popup-item--current {
    background: var(--gray-50);
    opacity: 0.6;
    cursor: default;
}

.popup-item__color {
    width: 3px;
    height: 40px;
    border-radius: 2px;
    flex-shrink: 0;
}

.popup-item__radio {
    width: 18px;
    height: 18px;
    border: 2px solid var(--border);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
    background: var(--background);
}

.popup-item--selected .popup-item__radio {
    border-color: var(--primary-600);
}

.popup-item__radio-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--primary-600);
    opacity: 0;
    transition: opacity 0.15s ease;
}

.popup-item--selected .popup-item__radio-dot {
    opacity: 1;
}

.popup-item__info {
    flex: 1 1;
    min-width: 0;
}

.popup-item__name {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.popup-item__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
    font-size: 12px;
    color: var(--text-tertiary);
}

.popup-item__badge {
    font-size: 10px;
    font-weight: 500;
    padding: 2px 8px;
    border-radius: var(--radius-full);
    background: var(--gray-100);
    color: var(--text-secondary);
}

.popup-item__badge--current {
    background: var(--primary-100);
    color: var(--primary-600);
}

.popup-loadmore {
    padding: 12px;
    text-align: center;
}

.popup-loadmore__btn {
    width: 100%;
    padding: 10px;
    border: 1px dashed var(--border);
    border-radius: var(--radius-md);
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);
}

.popup-loadmore__btn:hover {
    background: var(--gray-50);
    border-color: var(--primary-300);
    color: var(--primary-600);
}

.popup-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 20px;
    border-top: 1px solid var(--border);
    background: var(--gray-50);
}

.popup-footer__btn {
    padding: 10px 20px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color var(--transition-fast), border-color var(--transition-fast);
    background: var(--background);
    color: var(--text-primary);
}

.popup-footer__btn:hover {
    background: var(--gray-100);
}

.popup-footer__btn--primary {
    background: var(--primary-600);
    border-color: var(--primary-600);
    color: white;
}

.popup-footer__btn--primary:hover {
    background: var(--primary-700);
}

.popup-footer__btn--primary:disabled {
    background: var(--gray-300);
    border-color: var(--gray-300);
    cursor: not-allowed;
}

.popup-current-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: var(--warning-light);
    border-bottom: 1px solid var(--warning-border);
    font-size: 12px;
    color: var(--warning-text);
}

.popup-current-banner__icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

/* ========== Context Menu ========== */
.context-menu {
    position: fixed;
    min-width: 180px;
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    z-index: 9999;
    padding: 4px;
    opacity: 0;
    visibility: hidden;
}

.context-menu--open {
    opacity: 1;
    visibility: visible;
}

.context-menu__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    border-radius: var(--radius-md);
    transition: background 0.2s;
}

.context-menu__item:hover {
    background: var(--surface);
}

.context-menu__item--danger {
    color: var(--error);
}

.context-menu__item--danger:hover {
    background: var(--error-light);
}

.context-menu__item--project-add {
    color: var(--success);
}

.context-menu__item--project-add:hover {
    background: var(--success-light);
}

.context-menu__item--project-change {
    color: var(--info);
}

.context-menu__item--project-change:hover {
    background: var(--info-light);
}

.context-menu__item--project-remove {
    color: var(--warning);
}

.context-menu__item--project-remove:hover {
    background: var(--warning-light);
}

.context-menu__divider {
    height: 1px;
    background: var(--border);
    margin: 4px 0;
}

/* ========== Toast ========== */
.toast {
    position: fixed;
    bottom: 24px;
    right: 24px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    background: var(--gray-800);
    color: white;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    z-index: 99999;
    animation: slideIn 0.3s ease-out;
}

.toast--success {
    background: var(--success);
}

.toast--error {
    background: var(--error);
}

.toast--warning {
    background: var(--warning);
}

.toast--info {
    background: var(--info);
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* ========== Form Elements ========== */
.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
}

.form-label .required {
    color: var(--error);
    margin-left: 2px;
}

.form-input {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    font-size: 13px;
    font-family: var(--font-sans);
    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
    background: var(--background);
}

.form-input:focus {
    outline: none;
    border-color: var(--primary-400);
    box-shadow: var(--focus-ring);
}

.form-input::placeholder {
    color: var(--text-tertiary);
}

.form-hint {
    font-size: 12px;
    color: var(--text-tertiary);
    margin-top: 6px;
}

/* ========== Pagination ========== */
.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid var(--border);
}

.pagination__btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    background: var(--background);
    font-size: 13px;
    color: var(--text-secondary);
    cursor: pointer;
    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);
}

.pagination__btn:hover:not(:disabled) {
    border-color: var(--primary-300);
    color: var(--text-primary);
    background: var(--surface);
}

.pagination__btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination__page {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    background: var(--background);
    font-size: 13px;
    color: var(--text-secondary);
    cursor: pointer;
    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);
}

.pagination__page:hover {
    border-color: var(--primary-300);
    color: var(--text-primary);
}

.pagination__page--active {
    background: var(--primary-600);
    border-color: var(--primary-600);
    color: white;
}

/* ========== Empty State ========== */
.empty-state {
    text-align: center;
    padding: 60px 20px;
}

.empty-state__icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 16px;
    background: var(--gray-100);
    border-radius: var(--radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--gray-400);
}

.empty-state__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
}

.empty-state__desc {
    font-size: 14px;
    color: var(--text-tertiary);
}

/* ========== Scrollbar ========== */
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb:hover {
    background: var(--gray-400);
}

/* ========== 404 Not Found ========== */
.not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: var(--background);
}

.not-found__content {
    text-align: center;
    padding: var(--spacing-8);
}

.not-found__code {
    font-size: 120px;
    font-weight: 800;
    color: var(--primary-200);
    line-height: 1;
    margin-bottom: var(--spacing-4);
}

.not-found__message {
    font-size: 24px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: var(--spacing-3);
}

.not-found__description {
    font-size: 16px;
    color: var(--text-secondary);
    margin-bottom: var(--spacing-6);
}

.not-found__link {
    display: inline-block;
    padding: var(--spacing-3) var(--spacing-6);
    background: var(--primary-600);
    color: white;
    border-radius: var(--radius-md);
    text-decoration: none;
    font-weight: 600;
    transition: background-color var(--transition-fast);
}

.not-found__link:hover {
    background: var(--primary-700);
}

/* ========== AI 가상인물 표기 뱃지 (공정거래위원회 지침) ========== */
/* 실제 사람으로 오인할 수 있는 AI 생성 가상인물 이미지 배너에 표기.
   사용처 부모 컨테이너는 position: relative 여야 함. */
.ai-persona-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    padding: 3px 9px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.45;
    letter-spacing: 0.02em;
    white-space: nowrap;
    /* 어떤 이미지 위에서도 가독성 확보 위한 반투명 다크 오버레이 (토큰 없는 효과값) */
    color: #ffffff;
    background: rgba(17, 24, 39, 0.62);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    border-radius: var(--radius-full);
    pointer-events: none;
}

`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,UAAU;AACV;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA,sCAAsC;AACtC;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,kCAAkC;AAClC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sHAAsH;IACtH,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,6EAA6E;AACjF;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iFAAiF;AACrF;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,wFAAwF;AAC5F;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iFAAiF;AACrF;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;IAC7B,kFAAkF;AACtF;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,eAAe;IACf,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,sHAAsH;AAC1H;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,wFAAwF;IACxF,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,8CAA8C;IAC9C,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;AACjB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,+BAA+B;IAC/B,4BAA4B;IAC5B,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;IAC7B,kFAAkF;IAClF,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,6BAA6B;IAC7B,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,sHAAsH;AAC1H;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,+BAA+B;IAC/B,6BAA6B;IAC7B,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,sHAAsH;AAC1H;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,oCAAoC;AACpC;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,8BAA8B;IAC9B,YAAY;IACZ,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,8BAA8B;AAClC;;AAEA,qDAAqD;AACrD;0CAC0C;AAC1C;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,kDAAkD;IAClD,cAAc;IACd,kCAAkC;IAClC,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;IACjC,oBAAoB;AACxB","sourcesContent":["/* ========== Common Styles ========== */\n\n/* Reset */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: var(--font-sans);\n    background: var(--background);\n    color: var(--text-primary);\n}\n\n.class-selector__status--ended{\n    color: var(--text-tertiary);\n}\n\n.icon {\n    width: 20px;\n    height: 20px;\n    stroke: currentColor;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    fill: none;\n    flex-shrink: 0;\n}\n\n.icon--sm {\n    width: 16px;\n    height: 16px;\n}\n\n.icon--lg {\n    width: 24px;\n    height: 24px;\n}\n\n.app {\n    display: flex;\n    height: 100vh;\n}\n\n/* ========== Main Layout ========== */\n.main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    background: var(--surface);\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 72px 16px 24px;\n    background: var(--background);\n    border-bottom: 1px solid var(--border);\n}\n\n.page-header__left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.page-header__title {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.page-header__right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* ========== Buttons ========== */\n.btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 8px 16px;\n    border-radius: var(--radius-md);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);\n    border: none;\n    font-family: var(--font-sans);\n}\n\n.btn--primary {\n    background: var(--primary-600);\n    color: white;\n}\n\n.btn--primary:hover {\n    background: var(--primary-700);\n}\n\n.btn--outline {\n    background: var(--background);\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n}\n\n.btn--outline:hover {\n    background: var(--surface);\n    border-color: var(--primary-300);\n}\n\n.btn--sm {\n    padding: 6px 12px;\n    font-size: 12px;\n}\n\n.btn--lg {\n    padding: 12px 24px;\n    font-size: 14px;\n}\n\n/* ========== Modal ========== */\n.common-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity var(--transition-fast), visibility var(--transition-fast);\n}\n\n.common-modal-overlay--open {\n    opacity: 1;\n    visibility: visible;\n}\n\n.common-modal {\n    background: var(--background);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-md);\n    width: 100%;\n    max-width: 1000px;\n    max-height: 90vh;\n    overflow: hidden;\n    opacity: 0;\n    transition: opacity var(--transition-fast);\n}\n\n.common-modal-overlay--open .common-modal {\n    opacity: 1;\n}\n\n.modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--border);\n}\n\n.modal__title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.modal__close {\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: transparent;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    color: var(--text-tertiary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color var(--transition-fast), color var(--transition-fast);\n}\n\n.modal__close:hover {\n    background: var(--gray-100);\n    color: var(--text-primary);\n}\n\n.modal__body {\n    padding: 20px;\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n.modal__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 16px 20px;\n    border-top: 1px solid var(--border);\n    background: var(--gray-50);\n}\n\n.modal__btn {\n    padding: 8px 16px;\n    border: 1px solid var(--border);\n    background: var(--background);\n    border-radius: var(--radius-md);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast);\n}\n\n.modal__btn:hover {\n    background: var(--gray-100);\n}\n\n.modal__btn--primary {\n    background: var(--primary-600);\n    border-color: var(--primary-600);\n    color: white;\n}\n\n.modal__btn--primary:hover {\n    background: var(--primary-700);\n}\n\n.modal__btn--danger {\n    background: var(--error);\n    border-color: var(--error);\n    color: white;\n}\n\n.modal__btn--danger:hover {\n    background: var(--error-dark);\n}\n\n.modal--popup {\n    max-width: 480px;\n}\n\n.modal--popup .modal__body {\n    padding: 0;\n}\n\n.modal--popup .modal__header {\n    display: none;\n}\n\n/* ========== Popup Styles ========== */\n.popup-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 20px;\n    border-bottom: 1px solid var(--border);\n}\n\n.popup-header__icon {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--radius-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.popup-header__icon--purple {\n    background: var(--gray-100);\n    color: var(--primary-600);\n}\n\n.popup-header__icon--green {\n    background: var(--gray-100);\n    color: var(--success);\n}\n\n.popup-header__icon--blue {\n    background: var(--gray-100);\n    color: var(--info);\n}\n\n.popup-header__icon--warning {\n    background: var(--gray-100);\n    color: var(--warning);\n}\n\n.popup-header__text {\n    flex: 1;\n}\n\n.popup-header__title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.popup-header__subtitle {\n    font-size: 12px;\n    color: var(--text-tertiary);\n    margin-top: 2px;\n}\n\n.popup-close {\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: transparent;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    color: var(--text-tertiary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color var(--transition-fast), color var(--transition-fast);\n}\n\n.popup-close:hover {\n    background: var(--gray-100);\n    color: var(--text-primary);\n}\n\n.popup-search-bar {\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--border);\n    display: flex;\n    gap: 12px;\n}\n\n.popup-search {\n    flex: 1;\n    position: relative;\n}\n\n.popup-search__icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--text-tertiary);\n    pointer-events: none;\n}\n\n.popup-search__input {\n    width: 100%;\n    padding: 10px 12px 10px 40px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    font-size: 13px;\n    font-family: var(--font-sans);\n    background: var(--background);\n    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.popup-search__input:focus {\n    outline: none;\n    border-color: var(--primary-400);\n    box-shadow: var(--focus-ring);\n}\n\n.popup-search__input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.popup-list {\n    max-height: 320px;\n    overflow-y: auto;\n    padding: 8px;\n}\n\n.popup-list__empty {\n    text-align: center;\n    padding: 40px 20px;\n    color: var(--text-tertiary);\n    font-size: 13px;\n}\n\n.popup-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    transition: background 0.15s ease;\n    border: 1px solid transparent;\n}\n\n.popup-item:hover {\n    background: var(--gray-50);\n}\n\n.popup-item--selected {\n    background: var(--primary-50);\n    border-color: var(--primary-200);\n}\n\n.popup-item--current {\n    background: var(--gray-50);\n    opacity: 0.6;\n    cursor: default;\n}\n\n.popup-item__color {\n    width: 3px;\n    height: 40px;\n    border-radius: 2px;\n    flex-shrink: 0;\n}\n\n.popup-item__radio {\n    width: 18px;\n    height: 18px;\n    border: 2px solid var(--border);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: all 0.15s ease;\n    background: var(--background);\n}\n\n.popup-item--selected .popup-item__radio {\n    border-color: var(--primary-600);\n}\n\n.popup-item__radio-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--primary-600);\n    opacity: 0;\n    transition: opacity 0.15s ease;\n}\n\n.popup-item--selected .popup-item__radio-dot {\n    opacity: 1;\n}\n\n.popup-item__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.popup-item__name {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.popup-item__meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n    font-size: 12px;\n    color: var(--text-tertiary);\n}\n\n.popup-item__badge {\n    font-size: 10px;\n    font-weight: 500;\n    padding: 2px 8px;\n    border-radius: var(--radius-full);\n    background: var(--gray-100);\n    color: var(--text-secondary);\n}\n\n.popup-item__badge--current {\n    background: var(--primary-100);\n    color: var(--primary-600);\n}\n\n.popup-loadmore {\n    padding: 12px;\n    text-align: center;\n}\n\n.popup-loadmore__btn {\n    width: 100%;\n    padding: 10px;\n    border: 1px dashed var(--border);\n    border-radius: var(--radius-md);\n    background: transparent;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);\n}\n\n.popup-loadmore__btn:hover {\n    background: var(--gray-50);\n    border-color: var(--primary-300);\n    color: var(--primary-600);\n}\n\n.popup-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 16px 20px;\n    border-top: 1px solid var(--border);\n    background: var(--gray-50);\n}\n\n.popup-footer__btn {\n    padding: 10px 20px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast);\n    background: var(--background);\n    color: var(--text-primary);\n}\n\n.popup-footer__btn:hover {\n    background: var(--gray-100);\n}\n\n.popup-footer__btn--primary {\n    background: var(--primary-600);\n    border-color: var(--primary-600);\n    color: white;\n}\n\n.popup-footer__btn--primary:hover {\n    background: var(--primary-700);\n}\n\n.popup-footer__btn--primary:disabled {\n    background: var(--gray-300);\n    border-color: var(--gray-300);\n    cursor: not-allowed;\n}\n\n.popup-current-banner {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    background: var(--warning-light);\n    border-bottom: 1px solid var(--warning-border);\n    font-size: 12px;\n    color: var(--warning-text);\n}\n\n.popup-current-banner__icon {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n}\n\n/* ========== Context Menu ========== */\n.context-menu {\n    position: fixed;\n    min-width: 180px;\n    background: var(--background);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-md);\n    z-index: 9999;\n    padding: 4px;\n    opacity: 0;\n    visibility: hidden;\n}\n\n.context-menu--open {\n    opacity: 1;\n    visibility: visible;\n}\n\n.context-menu__item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    border-radius: var(--radius-md);\n    transition: background 0.2s;\n}\n\n.context-menu__item:hover {\n    background: var(--surface);\n}\n\n.context-menu__item--danger {\n    color: var(--error);\n}\n\n.context-menu__item--danger:hover {\n    background: var(--error-light);\n}\n\n.context-menu__item--project-add {\n    color: var(--success);\n}\n\n.context-menu__item--project-add:hover {\n    background: var(--success-light);\n}\n\n.context-menu__item--project-change {\n    color: var(--info);\n}\n\n.context-menu__item--project-change:hover {\n    background: var(--info-light);\n}\n\n.context-menu__item--project-remove {\n    color: var(--warning);\n}\n\n.context-menu__item--project-remove:hover {\n    background: var(--warning-light);\n}\n\n.context-menu__divider {\n    height: 1px;\n    background: var(--border);\n    margin: 4px 0;\n}\n\n/* ========== Toast ========== */\n.toast {\n    position: fixed;\n    bottom: 24px;\n    right: 24px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 18px;\n    background: var(--gray-800);\n    color: white;\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-md);\n    z-index: 99999;\n    animation: slideIn 0.3s ease-out;\n}\n\n.toast--success {\n    background: var(--success);\n}\n\n.toast--error {\n    background: var(--error);\n}\n\n.toast--warning {\n    background: var(--warning);\n}\n\n.toast--info {\n    background: var(--info);\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n/* ========== Form Elements ========== */\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-label {\n    display: block;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 8px;\n}\n\n.form-label .required {\n    color: var(--error);\n    margin-left: 2px;\n}\n\n.form-input {\n    width: 100%;\n    padding: 10px 14px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    font-size: 13px;\n    font-family: var(--font-sans);\n    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n    background: var(--background);\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: var(--primary-400);\n    box-shadow: var(--focus-ring);\n}\n\n.form-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.form-hint {\n    font-size: 12px;\n    color: var(--text-tertiary);\n    margin-top: 6px;\n}\n\n/* ========== Pagination ========== */\n.pagination {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 1px solid var(--border);\n}\n\n.pagination__btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 14px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    background: var(--background);\n    font-size: 13px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);\n}\n\n.pagination__btn:hover:not(:disabled) {\n    border-color: var(--primary-300);\n    color: var(--text-primary);\n    background: var(--surface);\n}\n\n.pagination__btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pagination__page {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    background: var(--background);\n    font-size: 13px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);\n}\n\n.pagination__page:hover {\n    border-color: var(--primary-300);\n    color: var(--text-primary);\n}\n\n.pagination__page--active {\n    background: var(--primary-600);\n    border-color: var(--primary-600);\n    color: white;\n}\n\n/* ========== Empty State ========== */\n.empty-state {\n    text-align: center;\n    padding: 60px 20px;\n}\n\n.empty-state__icon {\n    width: 64px;\n    height: 64px;\n    margin: 0 auto 16px;\n    background: var(--gray-100);\n    border-radius: var(--radius-lg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--gray-400);\n}\n\n.empty-state__title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 8px;\n}\n\n.empty-state__desc {\n    font-size: 14px;\n    color: var(--text-tertiary);\n}\n\n/* ========== Scrollbar ========== */\n::-webkit-scrollbar {\n    width: 6px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--gray-300);\n    border-radius: var(--radius-full);\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: var(--gray-400);\n}\n\n/* ========== 404 Not Found ========== */\n.not-found {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    background: var(--background);\n}\n\n.not-found__content {\n    text-align: center;\n    padding: var(--spacing-8);\n}\n\n.not-found__code {\n    font-size: 120px;\n    font-weight: 800;\n    color: var(--primary-200);\n    line-height: 1;\n    margin-bottom: var(--spacing-4);\n}\n\n.not-found__message {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: var(--spacing-3);\n}\n\n.not-found__description {\n    font-size: 16px;\n    color: var(--text-secondary);\n    margin-bottom: var(--spacing-6);\n}\n\n.not-found__link {\n    display: inline-block;\n    padding: var(--spacing-3) var(--spacing-6);\n    background: var(--primary-600);\n    color: white;\n    border-radius: var(--radius-md);\n    text-decoration: none;\n    font-weight: 600;\n    transition: background-color var(--transition-fast);\n}\n\n.not-found__link:hover {\n    background: var(--primary-700);\n}\n\n/* ========== AI 가상인물 표기 뱃지 (공정거래위원회 지침) ========== */\n/* 실제 사람으로 오인할 수 있는 AI 생성 가상인물 이미지 배너에 표기.\n   사용처 부모 컨테이너는 position: relative 여야 함. */\n.ai-persona-badge {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 2;\n    padding: 3px 9px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.45;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n    /* 어떤 이미지 위에서도 가독성 확보 위한 반투명 다크 오버레이 (토큰 없는 효과값) */\n    color: #ffffff;\n    background: rgba(17, 24, 39, 0.62);\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n    border-radius: var(--radius-full);\n    pointer-events: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
